import React, { useState, useEffect }  from "react";
import { connect } from "react-redux";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import "../../../Dashboard/dashboard.css";
import {generateForecastFreeCashFlow} from "../../../../store/modules/forecastFCF/actions";
import { useStyles, rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";

const AFTERTAX = "AFTERTAX"
const BEFORETAX = "PRETAX"

const ForecastFCF = ({
  taxes,
  forecastFreeCashFlow,
  appState,
  dispatchGenerateForecastFreeCashFlow
}) => {
  const classes = useStyles();
  const [selection, setSelection] = useState(AFTERTAX);

  // Mounted
  useEffect(() => {
    dispatchGenerateForecastFreeCashFlow()
  }, [])

  return (
    <>
      <div className="flex items-center justify-between pr-20">
        <h2 className="sectionHead">Forecasted Free Cash Flow</h2>
        <FormControl variant="outlined" sx={{ m: 1, minWidth: 170 }}>
          <InputLabel id="demo-simple-select-standard-label">Type</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={selection}
            onChange={(e) => setSelection(e.target.value)}
            label="Type"
          >
            <MenuItem value={AFTERTAX}>After - Tax</MenuItem>
            <MenuItem value={BEFORETAX}>Before - Tax</MenuItem>
          </Select>
        </FormControl>
      </div>
      
      <div className="dashboard-content">
        {selection == AFTERTAX ?
          (<>
            <div className="data-title-container">
              <div></div>

              <div className="data-title mt-3">
                <h6>{appState.companyData.name}</h6>
                <p>Forecast of Free Cash Flow After - Tax</p>
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Forecasted Discretionary Owner Earnings</InputLabel>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "50%",
                }}
              >
                <BVAInput
                  disabled
                  className={classes.input}
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-forecastedOwnerDiscretionaryEarnings"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.forecastedOwnerDiscretionaryEarnings}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: Reasonable Compensation</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  className={classes.input}
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-reasonableCompensation"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.reasonableCompensation}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>
                  {"EBITDA"}
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-ebitda"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.ebitda}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Depreciation and Amortization</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  textAlign="end"
                  id="fcf-forecastedFreeCashflowAfterTax-depreciation"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.depreciation
                  }
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>
                  {"Earnings Before Interest & Taxes (EBIT)"}
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-ebit"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.ebit}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: State Income Taxes - {taxes.stateTax}%</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  className={classes.input}
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-stateIncomeTaxes"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.stateIncomeTaxes}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Normalized Income After State Taxes</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-normalizedIncomeAfterStateTaxes"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.normalizedIncomeAfterStateTaxes}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: Federal Income Taxes - {taxes.federalTax}%</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-federalIncomeTaxes"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.federalIncomeTaxes}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Net Operating Profit After Tax (NOPAT)</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-nopat"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.nopat}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Add: Depreciation</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-addDepreciation"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.addDepreciation}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: Growth in Working Capital</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-growthWorkingCapital"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.growthWorkingCapital}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: Capital Expenditures</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-capitalExpenditures"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.capitalExpenditures}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  After-Tax Free Cash Flow
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  className={classes.input}
                  size="small"
                  id="fcf-forecastedFreeCashflowAfterTax-afterTaxFreeCashFlow"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax?.afterTaxFreeCashFlow}
                />
              </div>
            </div>
          </>)
          :
          (<>
            <div className="data-title-container">
              <div></div>
              <div className="data-title mt-3">
                <h6>{appState.companyData.name}</h6>
                <p>Forecast of Free Cash Flow Before - Tax</p>
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Forecasted Discretionary Owner Earnings</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  textAlign="end"
                  id="fcf-forecastedFreeCashflowBeforeTax-forecastedOwnerDiscretionaryEarnings"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowBeforeTax?.forecastedOwnerDiscretionaryEarnings}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: Reasonable Compensation</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowBeforeTax-reasonableCompensation"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowBeforeTax?.reasonableCompensation}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>
                  {"EBITDA"}
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowBeforeTax-ebitda"
                  textAlign="end"
                  startAdornment
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowBeforeTax?.ebitda}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: Growth in Working Capital</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowBeforeTax-growthWorkingCapital"
                  startAdornment
                  textAlign="end"
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowBeforeTax?.growthWorkingCapital}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Less: Capital Expenditures</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowBeforeTax-capitalExpenditures"
                  startAdornment
                  textAlign="end"
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowBeforeTax?.capitalExpenditures}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Pre-Tax Free Cash Flow
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="fcf-forecastedFreeCashflowBeforeTax-preTaxFreeCashFlow"
                  startAdornment
                  textAlign="end"
                  startAdornmentLabel="$"
                  value={forecastFreeCashFlow?.forecastedFreeCashFlowBeforeTax?.preTaxFreeCashFlow}
                />
              </div>
            </div>
          </>)
        }
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    taxes: state.taxes,
    appState: state.appState,
    forecastFreeCashFlow: state.forecastFCF.forecastFreeCashFlow
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateForecastFreeCashFlow() {
    dispatch(generateForecastFreeCashFlow())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ForecastFCF);
